// Import the Google Maps API Loader
import GoogleMapsLoader from 'google-maps-api-loader';

const countiesPath = scriptData.countiesPath;
const countyPolygons = [];

function initMap() {
  const map = new google.maps.Map(document.getElementById('map'), {
    center: { lat: 28.3067419076, lng: -82.438869799 },
    zoom: 8,
    gestureHandling: 'none',
  });

  const countyJSONFiles = [
      `${countiesPath}pasco.json`,
      `${countiesPath}hernando.json`,
      `${countiesPath}pinellas.json`,
      `${countiesPath}hillsborough.json`
  ];

  // Load all county polygons
  Promise.all(countyJSONFiles.map(file => fetch(file).then(response => response.json())))
    .then(dataArray => {
      dataArray.forEach(data => {
        const coordinates = data[0].geo_shape.geometry.coordinates[0].map(coord => {
          return { lng: coord[0], lat: coord[1] };
        });

        const countyPolygon = new google.maps.Polygon({
          paths: coordinates,
          strokeColor: '#FF0000',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#FF0000',
          fillOpacity: 0.35,
        });

        countyPolygon.setMap(map);
        countyPolygons.push(countyPolygon);
      });
    })
    .then(() => {
      // After loading polygons, add a marker for the city
      addCityMarker(map, scriptData.cityName);
    })
    .catch(error => console.error('Error fetching or parsing JSON:', error));
}

function addCityMarker(map, cityName) {
  const geocoder = new google.maps.Geocoder();

  geocoder.geocode({ address: cityName }, (results, status) => {
    if (status === 'OK' && results.length > 0) {
      const coordinates = {
        lat: results[0].geometry.location.lat(),
        lng: results[0].geometry.location.lng(),
      };

      // Add a marker for the city
      new google.maps.Marker({
        position: coordinates,
        map: map,
        title: cityName,
      });

      // Check if the city falls within any of the polygons
      checkCityInPolygons(coordinates, countyPolygons);
    } else {
      console.error(`Geocoding failed for ${cityName}. Status:`, status);
    }
  });
}

// Define a function to check if a city falls within any polygon
function checkCityInPolygons(cityCoordinates, countyPolygons) {
  const cityLatLng = new google.maps.LatLng(cityCoordinates.lat, cityCoordinates.lng);

  // Update the content of the serviceArea element based on the result
  const serviceAreaElement = document.getElementById('serviceArea');
  const cityName = scriptData.cityName;

  for (const polygon of countyPolygons) {
    if (google.maps.geometry.poly.containsLocation(cityLatLng, polygon)) {
      serviceAreaElement.innerHTML = `DNR Pest Control proudly serves ${cityName}!`;
      return true;
    }
  }

  serviceAreaElement.innerHTML = `DNR Pest Control proudly serves Hernando, Pasco, Pinellas and Hillsborough counties!`;
  return false;
}

// Load the Google Maps API with the API key and callback function
const googleMapsLoader = new GoogleMapsLoader({
  apiKey: 'AIzaSyDIk8bEd4lG0-gkrJ5kWO4mSAmyUh9EahY',
});

// Use the then method to execute code after the API is loaded
googleMapsLoader.then((googleApi) => {
  // Now you can use the Google Maps API
  initMap();

  // Get the city name from localized data
  const cityName = scriptData.cityName;

  // Check if the dynamically obtained city falls within any polygons
  checkCityInPolygons(cityName);
});
